export default class FileHelper {

  static getFileExtension(filename) {
    if (typeof filename !== 'string') {
      return null; // Handle invalid input
    }

    const parts = filename.split('.'); // Split by "."
    if (parts.length < 2) {
      return null; // No extension found
    }

    return parts.pop().toLowerCase(); // Return the last part in lowercase
  }
}
